import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            // Use setTimeout to ensure the element is rendered in the DOM
            // before attempting to scroll to it
            setTimeout(() => {
                const element = document.getElementById(hash.replace('#', ''));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 300);
        } else {
            // Use setTimeout(0) to ensure this happens after the new page has started rendering
            setTimeout(() => {
                // Reset all potential scroll containers
                window.scrollTo(0, 0);
                document.body.scrollTo(0, 0);
                document.documentElement.scrollTo(0, 0);

                // Force instant scroll if needed
                if ('scrollRestoration' in window.history) {
                    window.history.scrollRestoration = 'manual';
                }
            }, 0);
        }
    }, [pathname, hash]);

    return null;
}
